<template>
  <div>
    <div
      class="content-cell-item text-xs"
      v-for="(row, idx) in day"
      :key="row.class_name + idx"
    >
      <p class="font-medium">{{ row.class_name }}</p>
      <p>{{ convertDate(row.start, row.end) }}</p>
      <p>{{ row.time }}</p>
    </div>
  </div>
</template>
<script>
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "cell-schedule",
  props: ["day"],
  methods: {
    convertDate(startDate, endDate) {
      return `${convertDateFromServer(startDate, "date")} ${this.$t(
        "common.to"
      )} ${convertDateFromServer(endDate, "date")}`;
    }
  }
};
</script>
